import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Inject, Input, OnInit } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { DialogAnimation, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';
import { Observable } from 'rxjs';

import { AccaBoostLadderItem } from '../../../../reward-tokens/reward-tokens.model';
import { LadderNotification, MaxRewardNotification, NotificationType } from '../../../model';
import { NOTIFICATION_LADDER_VISIBLE, NOTIFICATION_LADDER_VISIBLE_PROVIDER } from '../../../services/digital/acca-boost-notification-sync.service';
import { CarouselAnimationService } from '../../../services/digital/carousel-animation.service';
import { AccaBoostLadderCarouselComponent } from '../acca-boost-ladder-carousel/acca-boost-ladder-carousel.component';
import { AccaBoostLadderUsInfoComponent } from '../acca-boost-ladder-us-info/acca-boost-ladder-us-info.component';

export interface ILadderItem extends AccaBoostLadderItem {
    selected: boolean;
    included: boolean;
}

@Component({
    selector: 'bs-acca-boost-ladder-carousel-us',
    templateUrl: './acca-boost-ladder-carousel-us.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NOTIFICATION_LADDER_VISIBLE_PROVIDER, CarouselAnimationService],
    styleUrls: ['./acca-boost-ladder-carousel-us.component.scss'],
    standalone: false,
})
export class AccaBoostLadderCarouselUsComponent extends AccaBoostLadderCarouselComponent implements OnInit {
    @Input() notification: LadderNotification | MaxRewardNotification;
    isMaxReward = false;
    modalHandler: ModalRef | null = null;
    nextLadderItems: ILadderItem[] = [];
    showLadder = false;
    isMaxLegAway = false;

    @HostBinding('class') className = 'us-ladder-container';

    constructor(
        public sitecore: Sitecore,
        @Inject(NOTIFICATION_LADDER_VISIBLE) notificationAnimationDone$: Observable<void>,
        changeRef: ChangeDetectorRef,
        timerService: TimerService,
        private dialogService: ModalDialogService,
    ) {
        super(notificationAnimationDone$, changeRef, timerService);
    }

    override resetLadderItems() {
        this.isMaxReward = this.notification?.type === NotificationType.MaxReward;
        this.ladderItems.set([]);
        const vm2 = this.vm.slice(0, this.vm.length - 1);
        this.maxItem = this.vm[this.vm.length - 1];

        if (!this.maxItem.selected) {
            const firstItem = vm2.find((t) => t.selected);
            const secondItem = vm2.find((t) => t.numberOfLegs === this.pickCount + 1);

            if (firstItem) {
                this.ladderItems.update((items) => [...items, firstItem]);
            }
            if (secondItem) {
                this.ladderItems.update((items) => [...items, secondItem]);
            }
        } else {
            this.ladderItems.update((item) => [...item, this.maxItem]);
        }

        this.updateNextLadderInfo();

        this.isMaxLegAway = this.pickCount === this.maxItem.numberOfLegs - 1;
        this.showLadder = this.pickCount < this.maxItem.numberOfLegs && !this.isMaxLegAway;
    }

    private updateNextLadderInfo(): void {
        if (this.ladderItems().length <= 0) {
            return;
        }

        this.nextLadderItems = this.vm.filter((v) => v.numberOfLegs > this.ladderItems()[0].numberOfLegs).slice(0, 2);
    }

    onClickInfo(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.modalHandler = this.dialogService.openDialog(AccaBoostLadderUsInfoComponent, {
            data: {
                pickCount: this.pickCount,
                notification: this.notification,
            },
            settings: {
                fit: false,
                showPageHeader: false,
                showDialogHeader: false,
                isModalDialog: true,
                animation: DialogAnimation.SlideInFromBottom,
                closeAnimation: DialogAnimation.SlideOutFromTop,
                cssClass: 'acca-boost-ladder-us-info-mobile',
            },
        });
    }
}
